<template>
    <v-app>

        <!-- Header -->
        <AppBar :pageTitle="text" />

        <!-- Main -->
        <v-main>

            <v-container class="content-container" :class="(webOrderStore.AppState.ProcessData.flowType === EnumFlowType.WEB || webOrderStore.AppState.ProcessData.flowType === EnumFlowType.SKLENI_SAM) && route.name != 'WebOrderEnd' ? 'content-container--wide' : ''">

                <div class="d-md-flex align-center">

                    <!-- Title -->
                    <div class="page-heading mt-0 d-md-none page-heading--main" >
                        {{ text }}
                    </div>

                </div>

                <!-- <v-row> -->
                    <slot></slot>
                <!-- </v-row> -->

            </v-container>

        </v-main>

        <!-- Footer -->
        <v-footer>

            <!-- Company -->
            <div class="footer__company">2025 © NLB d. d.</div>

            <!-- Footer links -->
            <div class="footer__link" @click="appStore.ToLinkNewTab('https://www.nlbbuygo.si/pravna-vsebina')">
                Pravna vsebina</div>
            <div class="footer__link" @click="appStore.DataHelpers.ShowCookies = true">Piškotki</div>
            <div class="footer__link"
                @click="appStore.ToLinkNewTab('https://www.bsi.si/sl/centralni-kreditni-register/sisbon')">SISBON</div>

        </v-footer>

        <!-- Cookies modal -->
        <Modal :display="appStore.DataHelpers.ShowCookies" :showCloseXButton="true" title="Obvestilo o piškotih"
            :showAcceptButton="true" :showDeclineButton="false"
            :acceptText="appStore.DataHelpers.ShowMore == true ? 'Nastavitve piškotkov' : 'Potrdi izbiro'"
            @accept="appStore.DataHelpers.ShowMore == true ? appStore.CookiesBack() : appStore.CookiesClearAndClose()"
            :btnCenter="true">
            <div v-if="appStore.DataHelpers.ShowMore == false">
                <div>
                    Tudi mi uporabljamo piškotke, ki nam s pomočjo statistik pomagajo,
                    da bo vaša izkušnja tukaj ena najboljših. A brez skrbi – so domači.
                    <br />
                    <br />
                    Več o piškotih si lahko preberete <span @click="appStore.DataHelpers.ShowMore = true"
                        class="link">tukaj</span>.
                    Izklopite ali vklopite pa jih lahko spodaj.
                </div>
                <div class="mt-8">
                    <v-checkbox v-model="appStore.PersonalData.Cookies" :value="ICookies.all"
                        label="Dovoli vse piškote"></v-checkbox>

                    <v-checkbox v-model="appStore.PersonalData.Cookies" :value="ICookies.some"
                        label="Dovoli nekatere piškote"></v-checkbox>

                    <div v-if="appStore.PersonalData.Cookies == ICookies.some" class="pl-10">
                        <span>Izberite piškotke, ki jih želite dovoliti</span>

                        <v-checkbox v-model="appStore.PersonalData.GoogleAnalytics" :value="ICookies.analytics"
                            label="Google Analytics"></v-checkbox>
                    </div>

                    <v-checkbox v-model="appStore.PersonalData.Cookies" :value="ICookies.none"
                        label="Ne dovoli nobenih piškotov"></v-checkbox>
                </div>

            </div>

            <div v-else-if="appStore.DataHelpers.ShowMore == true">
                <div class="subsection-heading">O pogojih uporabe</div>
                <div>
                    S pogoji uporabe piškotkov vam ponujamo informacije o tem, kako uporabljamo piškotke in podobne
                    tehnologije
                    na naši spletni strani.
                </div>

                <div class="subsection-heading">Piškotki</div>
                <div>
                    Ko uporabljate našo spletno stran, na vašo napravo pošljemo enega ali več piškotkov – majhne
                    tekstovne
                    datoteke, ki vključujejo alfanumerične znake. Pri tem lahko uporabimo sejne piškotke ali trajne
                    piškotke.
                    Sejni piškotki z vaše naprave izginejo takoj, ko zaprete okno brskalnika (ko se zaključi seja).
                    Trajni
                    piškotek pa v vaši napravi ostane tudi po tem, ko brskalnik zaprete, brskalnik pa ga lahko uporabi
                    ob vseh
                    naslednjih obiskih naše spletne strani. V povezavi z drugimi storitvami, ki so povezane z našo
                    spletno
                    stranjo, lahko uporabimo tudi piškotke tretjih oseb.
                </div>

                <div class="subsection-heading">Kako uporabljamo piškotke in podobne tehnologije</div>
                <div>Piškotke in avtomatično zbrane podatke lahko uporabimo za:
                    <ol>
                        <li>
                            prirejanje naše spletne strani in drugih storitev, povezanih z našo spletno stranjo, kot je
                            na primer
                            pomnenje vaših informacij z namenom, da vam jih ob naslednjem obisku naše spletne strani ali
                            drugih
                            storitev, povezanih z našo spletno stranjo, ne bi bilo treba ponovno vnesti;
                        </li>
                        <li>
                            prilagajanje oglasov,
                            vsebine in informacij;
                        </li>
                        <li>
                            spremljanje in analizo učinkovitosti našega spletnega mesta, drugih storitev,
                            povezanih z našo spletno stranjo, in oglaševalskimi aktivnostmi;
                        </li>
                        <li>spremljanje vseh metrik uporabe naše
                            spletne strani, kot je na primer skupno število obiskovalcev in število obiskanih strani.
                        </li>
                    </ol>

                    <br />
                    Tehnologija sledenja nam omogoča tudi urejanje in izboljšanje uporabnosti naše spletne strani, saj
                    lahko z
                    njo:
                    <ol>
                        <li>zaznamo, če ste bili v preteklosti že v kontaktu z našo spletno stranjo in</li>
                        <li>prepoznamo najbolj
                            priljubljene dele naše spletne strani.</li>
                    </ol>
                </div>

                <div class="subsection-heading">Kako lahko spremenim svoje nastavitve piškotkov?</div>
                <div>
                    Svojemu brskalniku z urejanjem nastavitev lahko naročite, da zavrne sprejemanje piškotkov katerekoli
                    spletne
                    strani, ki jo obiščete, s pomočjo ustrezne funkcije brskalnika pa lahko piškotke z vašega
                    računalnika ali
                    mobilne naprave tudi izbrišete. Če piškotke onemogočite, lahko določeni deli in vsebine naše spletne
                    strani
                    in storitev postanejo nedostopni, določene funkcionalnosti pa morda ne bodo delovale pravilno.
                    Za spreminjanje nastavitev piškotkov sledite navodilom brskalnika (ki se običajno nahajajo pod
                    zavihkom
                    “Pomoč”, “Orodja” ali “Urejanje”) ali kliknite na spodnjo povezavo “Spreminjanje nastavitev
                    piškotkov”.
                </div>
            </div>

        </Modal>

    </v-app>
</template>


<script setup lang="ts">
    import { computed } from "vue";
    import { EnumFlowType, OrderSummaryComponent } from "nlb-buy-go-library"
    import AppBar from "@components/layout/app-bar.vue";
    import { useAppStore } from "@/app/store/app/app-store";
    // import { useContractCreateStore } from "@/app/store/app/contract-create-store";
    import { useWebOrderStore } from "@/app/store/app/web-order-store";
    import { ICookies } from "@/app/store/app/app-store";
    import Modal from "@/app/components/modal.vue";
    import { useOrderSummaryData } from "@appstore/component/order-summary-component";
    import { useRoute } from "vue-router";

    const { OrderSummaryData } = useOrderSummaryData();

    const appStore = useAppStore();
    // const contractCreateStore = useContractCreateStore();
    const webOrderStore = useWebOrderStore();
    const route = useRoute();

    const text = computed(() => {
        if (route.fullPath.startsWith('/web')) {
            return 'Nakup na obroke'
        } else if (route.fullPath.startsWith('/limit')) {
            return 'Buy&Go Ready'
        } else if (route.fullPath.startsWith('/preapproved')) {
            return 'Buy&Go Ready'
        } else if (route.fullPath.startsWith('/preapproved/resume-limit')) {
            return 'Buy&Go Ready'
        } else if (route.fullPath.startsWith('/izracun')) {
            return 'Informativni izračun obrokov'
        } else if (route.fullPath.startsWith('/skleni-sam')) {
            return 'Buy&Go Direkt'
        } else if (route.fullPath.startsWith('/public/proforma-payment')) {
            return 'Buy&Go Direkt'
        } else if (route.fullPath.startsWith('/public/documentation')) {
            return 'Oddaja dokumentacije'
        } else if (route.fullPath.startsWith('/obroki')) {
            return 'Informativni izračun obrokov'
        } else if (route.fullPath.startsWith('/public/identification')) {
            return 'Identifikacija'
        }

        return 'Nakup na obroke'
    });
    //dev
    const imgPrefix: string = import.meta.env.VITE_HOST_URL;

</script>
